import React, { useState } from "react";
import CustomTabs from "components/tabs/customTab";
import { Send, Sparkles, Trophy } from "lucide-react";
import AwardStatusCard from "./AwardStatusCard";
import AwardCategoryCard from "./AwardCategoryCard";
import RecentNominationSummary from "./RecentNominationSummary";
import RecentAwardeeSummary from "./RecentAwardeeSummary";




const HyvidAwardsTab = () => {
  const [activeTab, setActiveTab] = useState("nominate");

  const TabLabel = ({ text, icon: Icon }) => {
    return (
      <div className="flex items-center justify-center gap-2">
        <span>{<Icon className="h-4 w-4" />}</span>
        <span className="text-sm font-medium">{text}</span>
      </div>
    );
  };
  const tabOptions = [
    {label: <TabLabel icon={Send} text="Nominate" />, value: "nominate"},
    {label: <TabLabel icon={Sparkles} text="My Nominations" /> ,value: "nominations"},
    {label: <TabLabel icon={Trophy} text="Award Winners" />, value: "award-winners"},
  ];

  return (
    <div className="flex flex-col gap-4">
      <CustomTabs
        tabs={tabOptions}
        height="h-10"
        activeTab={activeTab}
        onChange={setActiveTab}
      />
       
      <div className="mt-3 space-y-4">
        {activeTab === "nominate" &&
        <div className="space-y-6">
          <AwardStatusCard/>
          <AwardCategoryCard/>
        </div>
        }
        {activeTab === "nominations" &&
        <div className="space-y-6 ">
          <RecentNominationSummary/>
        </div>
        }
        {activeTab === "award-winners" &&
        <div className="space-y-6">
          <RecentAwardeeSummary/>
        </div>
        }
        
        
      </div>
    </div>
  );
};

export default HyvidAwardsTab;
